export default () => {
  const navbar = document.querySelector('.header__main-container');

  const sticky = navbar.offsetTop;

  function stickyMainNav() {
    if (window.pageYOffset >= sticky) {
      navbar.classList.add('sticky');
    } else {
      navbar.classList.remove('sticky');
    }
  }

  window.addEventListener('scroll', function() {
    stickyMainNav();
  });
};
